// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/create_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../google/types/date_pb";
import { file_google_types_date } from "../google/types/date_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/create_account.proto.
 */
export const file_accounts_create_account: GenFile = /*@__PURE__*/
  fileDesc("Ch1hY2NvdW50cy9jcmVhdGVfYWNjb3VudC5wcm90bxIPcHJvdG9zLmFjY291bnRzIqADChRDcmVhdGVBY2NvdW50UmVxdWVzdBI8CgZwYXJhbXMYASABKAsyLC5wcm90b3MuYWNjb3VudHMuQ3JlYXRlQWNjb3VudFJlcXVlc3QuUGFyYW1zGskCCgZQYXJhbXMSDAoEbmFtZRgBIAEoCRINCgVlbWFpbBgCIAEoCRIQCghwYXNzd29yZBgDIAEoCRIrCghiaXJ0aGRheRgEIAEoCzIZLnByb3Rvcy5nb29nbGUudHlwZXMuRGF0ZRI4ChJtYWluX3dvcmtfbG9jYXRpb24YBSABKA4yHC5wcm90b3MuZ2VuZXJhbC5Xb3JrTG9jYXRpb24SOAoSbWFpbl93b3JrX2Z1bmN0aW9uGAYgASgOMhwucHJvdG9zLmdlbmVyYWwuV29ya0Z1bmN0aW9uEjoKFG90aGVyX3dvcmtfZnVuY3Rpb25zGAcgAygOMhwucHJvdG9zLmdlbmVyYWwuV29ya0Z1bmN0aW9uEhUKDWNvbnRhY3RfZW1haWwYDyABKAkSHAoUY29udGFjdF9waG9uZV9udW1iZXIYECABKAkiYAoVQ3JlYXRlQWNjb3VudFJlc3BvbnNlEj0KBnJlc3VsdBgBIAEoCzItLnByb3Rvcy5hY2NvdW50cy5DcmVhdGVBY2NvdW50UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z", [file_google_types_date, file_general_work_location, file_general_work_function]);

/**
 * @generated from message protos.accounts.CreateAccountRequest
 */
export type CreateAccountRequest = Message<"protos.accounts.CreateAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.CreateAccountRequest.Params params = 1;
   */
  params?: CreateAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.CreateAccountRequest.
 * Use `create(CreateAccountRequestSchema)` to create a new message.
 */
export const CreateAccountRequestSchema: GenMessage<CreateAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_create_account, 0);

/**
 * @generated from message protos.accounts.CreateAccountRequest.Params
 */
export type CreateAccountRequest_Params = Message<"protos.accounts.CreateAccountRequest.Params"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string password = 3;
   */
  password: string;

  /**
   * @generated from field: protos.google.types.Date birthday = 4;
   */
  birthday?: Date | undefined;

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 5;
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: protos.general.WorkFunction main_work_function = 6;
   */
  mainWorkFunction: WorkFunction;

  /**
   * @generated from field: repeated protos.general.WorkFunction other_work_functions = 7;
   */
  otherWorkFunctions: WorkFunction[];

  /**
   * @generated from field: string contact_email = 15;
   */
  contactEmail: string;

  /**
   * @generated from field: string contact_phone_number = 16;
   */
  contactPhoneNumber: string;
};

/**
 * Describes the message protos.accounts.CreateAccountRequest.Params.
 * Use `create(CreateAccountRequest_ParamsSchema)` to create a new message.
 */
export const CreateAccountRequest_ParamsSchema: GenMessage<CreateAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_create_account, 0, 0);

/**
 * @generated from message protos.accounts.CreateAccountResponse
 */
export type CreateAccountResponse = Message<"protos.accounts.CreateAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.CreateAccountResponse.Result result = 1;
   */
  result?: CreateAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.CreateAccountResponse.
 * Use `create(CreateAccountResponseSchema)` to create a new message.
 */
export const CreateAccountResponseSchema: GenMessage<CreateAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_create_account, 1);

/**
 * @generated from message protos.accounts.CreateAccountResponse.Result
 */
export type CreateAccountResponse_Result = Message<"protos.accounts.CreateAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.CreateAccountResponse.Result.
 * Use `create(CreateAccountResponse_ResultSchema)` to create a new message.
 */
export const CreateAccountResponse_ResultSchema: GenMessage<CreateAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_create_account, 1, 0);

